import React, { useRef } from 'react';
import { __ } from '@wordpress/i18n';

// components
import { Toast } from 'primereact/toast';
import ListCompaniesTablePreInstructor from './components/ListCompaniesTablePreInstructor';


// TODO deprecated
const ManageSuppliers = () => {
    const toast = useRef(null);

    return (
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Aziende in valutazione', 'htr')}</h1>
            </div>

            <div className="appPage__spacer"></div>
            <Toast ref={toast}/>

            <div className="appPageSection">
                <ListCompaniesTablePreInstructor statuses={['EVALUATION', 'INTEGRATION_REQUESTED', 'INTEGRATION_EXPIRED']}/>
            </div>
        </div>
    )
}

export default ManageSuppliers;